
export const getProLicenseCount = (unlockProLicenseCount)=> {
  return unlockProLicenseCount ? '1-99' : '1-9'
}


export const getBizLicenseCount = (unlockBizLicenseCount, unlockBizMaxLicenseCount)=> {
  const minBizAndBizPlusLicenseCount = unlockBizLicenseCount ? 1 : 10;
  const maxBizAndBizPlusLicenseCount = unlockBizMaxLicenseCount ? 250 : 99;
  return `${minBizAndBizPlusLicenseCount}-${maxBizAndBizPlusLicenseCount}`
}

export const getEnterpriseLicenseCount = (unlockBizMaxLicenseCount)=> {
  return unlockBizMaxLicenseCount ? '> 250' : '100+'
}
